export const NO_TRADE_GROUP_ID = "No trade group id"; // used to id selected accounts (grouped together) which don't have a trade group
